export default "__VITE_ASSET__CLPyYoWL__"